import { zodResolver } from '@hookform/resolvers/zod';
import { useState } from 'react';
import { useForm } from 'react-hook-form';

// Schemas
import { formAddDependientesSchema } from '../schema';

// Components
import { AlertCustom, ButtonCustom, Form } from '../../../../atoms';
import { FieldFormDependiente } from './Field-form';

// Constants
import { useCotizador } from '../../../../../hooks/others';
import { capitalizarPalabra } from '../../../../../core/utils';
import {
  limpiarEspacios,
  validateUniqueIdentificationsSet,
} from '../../../../../core/utils/functions';
import { useGetSeguros } from '../../../../molecules/CardSeguroTitulo/query';

export function FormDependiente({
  handleSubmit = () => null,
  isPasoEmision = false,
  formData = {},
}) {
  const [open, setOpen] = useState(false);
  const { mostrarCampos, handleRegresarPaso, dataCotizar } = useCotizador();

  const { data } = useGetSeguros();

  const seguroSelected = data.data?.find(
    seguro => seguro.codigo === dataCotizar?.seguro?.codigo,
  );

  const form = useForm({
    resolver: zodResolver(formAddDependientesSchema),
    defaultValues: {
      dependientes: getDependientesContext(
        dataCotizar.datosPersonales?.dependientes,
      ),
    },
  });

  async function onSubmit(values) {
    const dependientes = values?.dependientes?.map(({ ...rest }) => ({
      ...rest,
      nombreCompleto: limpiarEspacios(rest?.nombreCompleto),
    }));

    if (validateUniqueIdentificationsSet(dependientes)) {
      return setOpen(true);
    }

    await handleSubmit(dependientes);
  }

  return (
    <>
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <div className="flex flex-col gap-24 lg:max-w-[98.5%]">
            <FieldFormDependiente isPasoEmision={isPasoEmision} />

            <div className="flex flex-col items-center">
              {seguroSelected?.OTPValidate &&
              isPasoEmision &&
              formData?.telefono ? (
                <div className="text-primary-content text-base w-full text-center pb-7 -mt-5 ">
                  Te enviaremos un mensaje de texto de verificación en los
                  siguientes pasos al número:&nbsp;
                  <b>{formData?.telefono}</b>
                </div>
              ) : null}

              <ButtonCustom
                type="submit"
                text="Confirmar"
                width="180px"
                disabled={!mostrarCampos}
              />

              <ButtonCustom
                text="Regresar"
                variant="text"
                className="color-primary fontPSemiBold text-base  mt-3 cursor-pointer underline  lg:text-lg hover:bg-transparent"
                onClick={handleRegresarPaso}
                typeColor="general"
              />
            </div>
          </div>
        </form>
      </Form>

      <AlertCustom
        title="¡Número de identificación incorrecto!"
        description="Las identidades deben ser diferentes."
        open={open}
        setOpen={setOpen}
        severity="error"
      />
    </>
  );
}

function getDependientesContext(dependientes = []) {
  if (dependientes.length < 1) {
    return [];
  }

  return dependientes.map(({ ...rest }) => {
    return {
      ...rest,
      genero: capitalizarPalabra(rest?.genero),
      nombreCompleto: limpiarEspacios(rest?.nombreCompleto),
    };
  });
}
